import AuthAxios from 'utils/authAxios';
import AffiliatePayments from './affiliate-payments';
import CoManagerDocuments from './comanager-documents';
import Codes from './codes';
import DSPs from './dsps';
import DistributionJobs from './distributionJobs';
import Groups from './groups';
import Parties from './parties';
import Payees from './payees';
import PlatformFees from './platformFees';
import RecoupAccountPassthroughs from './recoupAccountPassthroughs';
import RecoupAccountTracks from './recoupAccountTracks';
import RecoupAccounts from './recoupAccounts';
import RecoupLedgers from './recoupLedgers';
import Releases from './releases';
import ReportFiles from './reportFiles';
import ReportInvoices from './reportInvoices';
import RoyaltyTransfers from './royaltyTransfers';
import ServiceDeals from './service-deals';
import Splits from './splits';
import SubscriptionMemberships from './subscriptionMemberships';
import TrackRevenues from './track-revenues';
import Tracks from './tracks';
import Users from './users';
import DiscoveryModeTracks from './discovery-mode-tracks';
import LinkfireIngestionHistory from './linkfire-ingestion-history';
import QueryLibrary from './query-library';

const WaitForJob = async (job, onUpdate) => {
  let jobStatus = { status: 'pending' };

  while (jobStatus.status === 'pending' || jobStatus.status === 'active') {
    jobStatus = await AuthAxios.get(job.data.refreshUrl)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

    if (typeof onUpdate === 'function') {
      onUpdate(jobStatus);
    }

    if (jobStatus.status === 'pending' || jobStatus.status === 'active') {
      // Sleep 5 seconds
      await new Promise(resolve => setTimeout(resolve, 5000));
    }
  }

  return jobStatus?.result;
};

export {
  AffiliatePayments,
  CoManagerDocuments,
  Codes,
  DSPs,
  DistributionJobs,
  Groups,
  Parties,
  Payees,
  PlatformFees,
  RecoupAccountPassthroughs,
  RecoupAccountTracks,
  RecoupAccounts,
  RecoupLedgers,
  Releases,
  ReportFiles,
  ReportInvoices,
  RoyaltyTransfers,
  ServiceDeals,
  Splits,
  SubscriptionMemberships,
  TrackRevenues,
  Tracks,
  Users,
  WaitForJob,
  DiscoveryModeTracks,
  LinkfireIngestionHistory,
  QueryLibrary,
};
